module.exports = __webpack_public_path__ + "img/team_2.969968e9.png";